import {
  Creator as ApiCreator,
  IdealistDayEvent as ApiIdealistDayEvent,
  fetchEvent as apiFetchEvent,
} from 'api/groups';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle, no-restricted-imports
import { Dispatch, GetState } from '..';
import { setError } from './error';

// Types

export type IdealistDayEvent = ApiIdealistDayEvent & {
  isFetching: boolean;
};
export type Creator = ApiCreator;
export type State = {
  byId: Record<
    string,
    IdealistDayEvent & {
      isFetching: boolean;
    }
  >;
};

type FetchEventRequestAction = {
  type: 'FETCH_IDEALIST_DAY_EVENT_REQUEST';
  eventId: string;
};
type FetchEventSuccessAction = {
  type: 'FETCH_IDEALIST_DAY_EVENT_SUCCESS';
  event: IdealistDayEvent;
  creator: Creator | null | undefined;
};
export type Action = FetchEventRequestAction | FetchEventSuccessAction;

// Reducer

// eslint-disable-next-line import/no-default-export
export default function idealistDayEventsReducer(
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: State = {
    byId: {},
  },
  action: Action
) {
  switch (action.type) {
    case 'FETCH_IDEALIST_DAY_EVENT_REQUEST':
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.eventId]: {
            ...state.byId[action.eventId],
            id: action.eventId,
            isFetching: true,
          },
        },
      };

    case 'FETCH_IDEALIST_DAY_EVENT_SUCCESS':
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.event.id]: { ...action.event, isFetching: false },
        },
      };

    default:
      return state;
  }
}

// Actions

const fetchEventRequest = (eventId: string): FetchEventRequestAction => ({
  type: 'FETCH_IDEALIST_DAY_EVENT_REQUEST',
  eventId,
});

const fetchEventSuccess = (
  event: IdealistDayEvent,
  creator: Creator | null | undefined
): FetchEventSuccessAction => ({
  type: 'FETCH_IDEALIST_DAY_EVENT_SUCCESS',
  event,
  creator,
});

export const fetchEvent =
  (eventId: string, force = false) =>
  (dispatch: Dispatch, getState: GetState) => {
    const state = getState();
    const event = state.idealistDayEvents.byId[eventId];

    if (!event || (force && !event.isFetching)) {
      dispatch(fetchEventRequest(eventId));
      apiFetchEvent(eventId)
        .then((fetchedEvent) => {
          // @ts-expect-error ts-migrate(2554) FIXME: Expected 2 arguments, but got 1.
          dispatch(fetchEventSuccess(fetchedEvent));
        })
        .catch((e) => {
          dispatch(setError(e));
        });
    }
  };

export const updateEvent = fetchEventSuccess;
